import { getUserAvailableBonuses } from "@actions/bonus";
import FormItem from "@components/formItem";
import { MaskedInput, MaskedInputLabel } from "@pages/profile-v2/pages/withdraw/baseItems";
import React, { Fragment } from "react";
import MaskInput from "react-maskinput";
import { connect } from "react-redux";
import {
	Box,
	Content,
	ContentTitle,
	FailureImg,
	ResultContent,
	ResultText,
	SuccessImg,
} from "../baseItems";
import Base from "./base";

class PromotionalCode extends Base {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			code: "",
			codeValue: "",
			showCodeMask: false,
			canForward: false,
		};
		this.codeInputRef = React.createRef();
	}

	handleFocus = (field) => {
		this.setState({ [field]: true });
	};

	handleBlur = (field, value) => {
		const cleanedValue = value.replace(/_/g, "").trim();
		const isEmptyOrMasked = cleanedValue === "";
		this.setState(
			{
				[field]: false,
				[`${field.replace("show", "").toLowerCase()}Value`]: isEmptyOrMasked
					? ""
					: cleanedValue,
			},
			this.checkRequiredFields
		);
	};

	onEnterValue = (field, e) => {
		console.log(e.target.value);
		const value = e.target.value.replace(/_/g, "").trim();
		this.setState({ [field]: value, [`${field}Value`]: value }, this.checkRequiredFields);
	};

	checkRequiredFields = () => {
		const { codeValue } = this.state;
		if (codeValue) {
			this.setState({ canForward: true });
		} else {
			this.setState({ canForward: false });
		}
	};

	getStep1(translate) {
		const { showCodeMask, codeValue } = this.state;
		return (
			<Content>
				<ContentTitle>{translate("ENTER_PROMOTIONAL_CODE")}</ContentTitle>
				<FormItem onRegister={() => this.registerField({ name: "code" })}>
					<Box>
						<MaskedInput>
							<MaskInput
								ref={this.codeInputRef}
								alwaysShowMask={window.IS_MARS ? true : false}
								onFocus={() => this.handleFocus("showCodeMask")}
								onBlur={(e) => this.handleBlur("showCodeMask", e.target.value)}
								value={showCodeMask ? codeValue : this.state.code}
								mask="***********************************"
								maskChar={showCodeMask ? "_" : ""}
								size={35}
								onChange={(e) => this.onEnterValue("code", e)}
							/>
							<MaskedInputLabel
								isFocused={showCodeMask}
								hasValue={codeValue}>
								{translate("PROMOTIONAL_CODE")}
							</MaskedInputLabel>
						</MaskedInput>
					</Box>
				</FormItem>
			</Content>
		);
	}

	goForward() {
		if (!this.state.canForward) return;

		this.makeExternalPayment(3);
	}

	getStep3(translate) {
		const { showSuccessWindow, showFailWindow } = this.state;
		return (
			<Fragment>
				{showSuccessWindow && (
					<Content>
						<ResultContent>
							<SuccessImg></SuccessImg>
							<ResultText>{translate("PAYMENT_APPROVED")}</ResultText>
						</ResultContent>
					</Content>
				)}
				{showFailWindow && (
					<Content>
						<ResultContent>
							<FailureImg></FailureImg>
							<ResultText>{translate("PAYMENT_REJECTED")}</ResultText>
						</ResultContent>
					</Content>
				)}
			</Fragment>
		);
	}

	makeExternalPayment(newStep) {
		const { code } = this.state;
		this.props.externalFunc.makeDeposit(code, (data) => {
			const isSuccess = data.message === "OK";
			this.setState({
				showSuccessWindow: isSuccess,
				showFailWindow: !isSuccess,
				currentStep: newStep,
			});
		});
	}

	render() {
		const { canForward } = this.state;
		return super.render();
	}
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
	getUserAvailableBonuses,
};

export default connect(mapStateToProps, mapDispatchToProps)(PromotionalCode);
